import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import EditSurveyForm from '../components/EditSurveyForm';
import EditQuestionsGroups from '../components/EditQuestionsgroups';
import { Row, Col } from 'react-bootstrap';
import SurveyShareManager from '../components/SurveyShareManager';

const EditSurvey = () => {
  const navigate = useNavigate();
  const surveyId = localStorage.getItem('selectedSurveyId'); // Obtiene el ID de localStorage

  useEffect(() => {
    if (!surveyId) {
      toast.error('No se encontró el ID de la encuesta.', { theme: 'colored' });
      navigate('/surveys'); // Redirige si no hay ID
    }
  }, [surveyId, navigate]);

  return (
    <>
      <Row>
        <Col>
          <EditSurveyForm id={surveyId} />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <EditQuestionsGroups survey_id={surveyId} />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <SurveyShareManager surveyId={surveyId} />
        </Col>
      </Row>
    </>
  );
};

export default EditSurvey;
